import React, { createContext, useContext, useState } from "react";
import AuthApi from "../services/api/authApi";
import { toast } from "react-toastify";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("userInfo");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [searchProfileData, setSearchProfileData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [perPage, setPerPage] = useState(8);

  const fetchUserInfo = async () => {
    try {
      const response = await AuthApi.getAuthenticatedUser();

      if (response.code === 200) {
        setUser(response.data);
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        return response.data;
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {}
  };

  return (
    <UserContext.Provider value={{ user, fetchUserInfo, searchProfileData, setSearchProfileData, currentPage, setCurrentPage, totalPages, setTotalPages, setPerPage, perPage }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
